import { campaignMetrics, ChartDataResponse, MetricInfo, MetricLabels } from "@api/common";
import { AppState, currentReportCampaign } from "@store";
import { FetchingState } from "rd-redux-http";
import * as React from "react";
import { connect } from "react-redux";
import "./DynamicSpiderCharts.css";
import { LegendItem } from "./LegendItem";
import { ReportLabel } from "./ReportLabel";
import { SpiderWebChart, SpiderWebChartData } from "./SpiderWebChart";

interface ChartWrapperState {
    selectedMetric: MetricInfo;
}

interface ChartWrapperProps {
    chartData: ChartDataResponse;
    metrics: MetricInfo[];
}

class DynamicSpiderChartsComponent extends React.Component<ChartWrapperProps, ChartWrapperState> {
    constructor(props: any) {
        super(props);
        this.state = {
            selectedMetric: props.metrics[0]
        };
    }

    prepareData(metric: string): SpiderWebChartData {
        const { chartData } = this.props;
        const matchData = chartData.metrics.filter(item => metric == item.metric);

        const data = matchData[0] ? matchData[0].data : [];

        return data.map(item => {
            return {
                value: item["metric-value"],
                day: item["dimension-values"][0] as any
            };
        });
    }

    render() {
        const { selectedMetric } = this.state;
        const { metrics } = this.props;

        const rateMetric =
            metrics.find(m => m.metric === selectedMetric.rateMetric) || metrics.filter(m => m.isRate)[0];

        return (
            <div className="DynamicSpiderCharts">
                <div className="DynamicSpiderCharts__legend">
                    {metrics.filter(m => !m.isRate).map(metric => {
                        return (
                            <LegendItem
                                color={metric.color}
                                checked={selectedMetric.metric == metric.metric}
                                key={`legend-${metric.metric}`}
                                onChange={() =>
                                    this.setState({
                                        selectedMetric: metric
                                    })
                                }
                            >
                                {MetricLabels.metricSwitcher(metric)}
                            </LegendItem>
                        );
                    })}
                </div>
                <div className="DynamicSpiderCharts__charts">
                    <div className="DynamicSpiderCharts__chart">
                        <ReportLabel title={"Rate"} subtitle={MetricLabels.overDaysOfWeekHeader(rateMetric)} />
                        <SpiderWebChart
                            color={rateMetric.color}
                            data={this.prepareData(rateMetric.metric)}
                            showAsPercent
                        />
                    </div>
                    <div className="DynamicSpiderCharts__chart">
                        <ReportLabel title={"Count"} subtitle={MetricLabels.overDaysOfWeekHeader(selectedMetric)} />
                        <SpiderWebChart color={selectedMetric.color} data={this.prepareData(selectedMetric.metric)} />
                    </div>
                </div>
            </div>
        );
    }
}

export const DynamicSpiderCharts = connect((state: AppState) => {
    const campaign = currentReportCampaign(state);
    const metrics = campaignMetrics(campaign ? campaign.unit : "CPM");

    return {
        chartData: FetchingState.getDataOrDefault(state.reports.chartData.weekdayData, { metrics: [], dimensions: [] }),
        metrics
    };
})(DynamicSpiderChartsComponent);
